import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ConfigurationRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/configuration/pipeline', { replace: true });
  }, [navigate]);

  return null;
};

export default ConfigurationRedirect;
